import { DotLegalAlert } from "@dotlegal/dotlegal-ui-components";
import { useTranslation } from "@localization/useTranslation";
import { useRiskAreaEntityAccess } from "./useRiskAreaEntityAccess";

interface RiskEntityAccessBannerProps {
    riskAreaId: string | undefined;
    marginBottom?: boolean;
}

function RiskEntityAccessBanner({ riskAreaId, marginBottom }: RiskEntityAccessBannerProps) {
    const { translateString } = useTranslation();
    const { hasAccessToAllEntities } = useRiskAreaEntityAccess(riskAreaId);

    if (hasAccessToAllEntities) return null;

    return <DotLegalAlert marginBottom={marginBottom ? 2 : undefined} severity="warning" warningText={translateString("riskEntityAccessRestrictedWarning")} />;
}

export default RiskEntityAccessBanner;
